import { render } from "./InternationalProjects.vue?vue&type=template&id=13e34430&scoped=true"
import script from "./InternationalProjects.vue?vue&type=script&lang=js"
export * from "./InternationalProjects.vue?vue&type=script&lang=js"

import "./InternationalProjects.vue?vue&type=style&index=0&id=13e34430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e34430"]])

export default __exports__